module.exports = __webpack_public_path__ + "static/media/search-icon.bc9c5185.png";